module.exports = require("core-js/library/fn/is-iterable");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/is-iterable.js
// module id = 462
// module chunks = 52252321336229